import classNames from "classnames";
import { FC } from "react";
import Colors from "~/constants/colors";
import Icon from "../Icon";
import Text, { TextProps } from "../Text";
import styles from "./TextIcon.module.scss";

interface TextIconProps {
  icon?: string;
  iconColor?: string;
  text: string;
  textType?: TextProps["type"];
  textColor?: string;
  onBack?: () => void;
  className?: string;
  iconClassName?: string;
  textClassName?: string;
}

const TextIcon: FC<TextIconProps> = ({
  icon,
  iconColor = Colors.GREY_00,
  text,
  textType = "label-2",
  textColor = Colors.PRIMARY,
  onBack,
  className,
  iconClassName,
  textClassName,
}) => {
  return (
    <div className={classNames(styles.text_icon, className)}>
      {onBack && (
        <Icon
          name="arrow-square-left-2"
          size={40}
          className={styles.back_icon}
          onClick={onBack}
        />
      )}
      {icon && (
        <div className={classNames(styles.icon, iconClassName)}>
          <Icon name={icon} size={20} color={iconColor} />
        </div>
      )}

      <Text type={textType} color={textColor} className={textClassName}>
        {text}
      </Text>
    </div>
  );
};

export default TextIcon;
